import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import PropTypes from 'prop-types';

const ConnectorCard = ({ icon, label, description, iconBgColor = '#F1F5FF', sx = {} }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        width: '200px',
        height: '70px',
        p: { xs: 1, sm: 1, md: 1 },
        borderRadius: '4px',
        bgcolor: '#F9FAFB',
        border: '1px solid #E5E7EB',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: { xs: 1, sm: 1.25 },
        ...sx,
      }}
    >
      <Box
        sx={{
          width: { xs: 40, sm: 44, md: 48 },
          height: { xs: 40, sm: 44, md: 48 },
          borderRadius: '4px',
          bgcolor: iconBgColor,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontFamily: 'IBM Plex Sans, sans-serif',
            fontWeight: 600,
            fontSize: { xs: '0.875rem', sm: '0.9375rem', md: '1rem' },
            lineHeight: 1.2,
            color: '#000000',
            mb: 0.25,
          }}
        >
          {label}
        </Typography>
        {description && (
          <Typography
            sx={{
              fontFamily: 'IBM Plex Sans, sans-serif',
              fontWeight: 400,
              fontSize: { xs: '0.75rem', sm: '0.8125rem', md: '0.875rem' },
              lineHeight: 1.4,
              color: '#6B7280',
            }}
          >
            {description}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

ConnectorCard.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  iconBgColor: PropTypes.string,
  sx: PropTypes.object,
};

export default ConnectorCard;
